// src/stone/icons/AgentStone.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AgentStone = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M7.4 24V11h1.2v13z" }),
      /* @__PURE__ */ jsx("path", { d: "M16 23.6H8v-1.2h8z" }),
      /* @__PURE__ */ jsx("path", { d: "M15.4 24V11h1.2v13z" }),
      /* @__PURE__ */ jsx("path", { d: "M6.819 10.3a1.6 1.6 0 0 1 1.061-.4h.001l-.001.6v-.6h8.24a1.6 1.6 0 0 1 1.062.403l3.617 3.215a1.6 1.6 0 0 1 .336 1.973l-2.402 4.325-1.05-.583 2.403-4.324a.4.4 0 0 0-.084-.494l-3.616-3.214a.4.4 0 0 0-.266-.101H7.878a.4.4 0 0 0-.265.1L4 14.415a.4.4 0 0 0-.085.493l2.402 4.324-1.05.583-2.4-4.324a1.6 1.6 0 0 1 .335-1.973zM12 1.6a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8M7.9 4.5a4.1 4.1 0 1 1 8.2 0 4.1 4.1 0 0 1-8.2 0" })
    ]
  }
);
var AgentStone_default = AgentStone;

export {
  AgentStone_default
};
